<template>
  <div class="row justify-content-center">
    <div class="col-md-10 col-lg-8 col-xl-9 col-xxl-8 col-xxxl-6">
      <div
        class="card mb-25 border-0 rounded-0 bg-white authentication-card"
        style="margin-top: 5rem"
      >
        <div class="card-body letter-spacing">
          <h4 class="text-black fw-bold mb-0 text-center">
            Connectez-vous à votre compte!
          </h4>
          <form @submit.prevent="handleLogin">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Adresse e-mail
              </label>
              <input
                type="email"
                v-model="email"
                class="form-control shadow-none rounded-0 text-black"
                placeholder=""
              />
            </div>
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Mot de passe
              </label>
              <input
                type="password"
                v-model="password"
                class="form-control shadow-none rounded-0 text-black"
                placeholder="**************"
              />
            </div>
            <div
              class="d-flex align-items-center justify-content-between mb-15 mb-md-20"
            >
              <!-- <div
                class="form-check form-check-primary mb-0 fs-md-15 fs-lg-16 text-muted lh-1"
              >
                <input
                  class="form-check-input shadow-none"
                  type="checkbox"
                  id="remember-me"
                />
                <label class="form-check-label" for="remember-me">
                  Remember Me
                </label>
              </div> -->
              <!-- <router-link
                to="/forgot-password"
                class="forgot-password-btn fs-md-15 fs-lg-16 text-decoration-none position-relative text-primary"
              >
                Forgot Password?
              </router-link> -->
            </div>
            <button
              class="default-btn transition border-0 fw-medium text-white rounded-1 fs-md-15 fs-lg-16 bg-success d-block w-100"
              type="submit"
            >
              Se connecter
            </button>
            <span
              class="d-block text-muted text-center mt-15 mt-md-30 mb-12 mb-md-20 fs-md-15 fs-lg-16"
            >
                Vous n'avez pas de compte ?
            </span>
            <router-link
              to="/register"
              class="default-btn with-border transition fw-medium rounded-1 fs-md-15 fs-lg-16 d-block w-100 text-decoration-none text-center"
            >
                Créer un compte
            </router-link>
            <span
              class="d-block or text-muted text-center mt-15 mb-15 mt-md-20 mb-md-20 fs-md-15 fs-lg-16 position-relative z-1 lh-1"
            >
              <!-- <span class="d-inline-block bg-white">Or</span> -->
            </span>
            <!-- <ul class="socials ps-0 mb-0 list-unstyled text-center">
              <li class="d-inline-block">
                <button
                  type="button"
                  class="d-block rounded-circle text-center position-relative facebook border-0 p-0"
                >
                  <i class="ph-fill ph-facebook-logo"></i>
                </button>
              </li>
              <li class="d-inline-block">
                <button
                  type="button"
                  class="d-block rounded-circle text-center position-relative google border-0 p-0"
                >
                  <i class="ph-bold ph-google-logo"></i>
                </button>
              </li>
              <li class="d-inline-block">
                <button
                  type="button"
                  class="d-block rounded-circle text-center position-relative twitter border-0 p-0"
                >
                  <i class="ph-fill ph-twitter-logo"></i>
                </button>
              </li>
              <li class="d-inline-block">
                <button
                  type="button"
                  class="d-block rounded-circle text-center position-relative linkedin border-0 p-0"
                >
                  <i class="ph-fill ph-linkedin-logo"></i>
                </button>
              </li>
            </ul> -->
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, getCurrentInstance } from "vue";
import axios from "axios";
import { useRouter } from "vue-router";
import api from "@/utils/axios";
import { useAuthStore } from "@/stores/auth";
import { useAppToast } from "@/composables/useAppToast";

export default {
  name: "LoginForm",

  setup() {
    const { showToast } = useAppToast();

    const email = ref("");
    const password = ref("");
    const router = useRouter();
    const { proxy } = getCurrentInstance() || {};

    const handleLogin = async () => {
      try {
        const auth = useAuthStore();
        const response = await api.post("/api/auth/login", {
          email: email.value,
          password: password.value,
        });

        if (response.data && response.data.access_token && response.data.user) {
          // Assuming the API returns a token
          console.log("Login successful:", response.data.access_token);
          const token = response.data.access_token;
          auth.setToken(response.data.access_token); // Save token
          auth.setUser(response.data.user);
          auth.setPermissions(response.data.permissions);

          // console.log("User data:", auth.token, auth.user);

          // localStorage.setItem("permissions", response.permissions);
          // localStorage.setItem("notifs", response.count);

          // proxy.$showSuccessToast('Login successful');
          // toast.add({
          //   severity: "success",
          //   summary: "Success",
          //   detail: "Operation completed",
          //   life: 3000,
          // });
          showToast("Connexion réussie", "success");

          // console.log("Login successful:", response.data);
          // Redirect user after login
          router.push("/").then(() => {
            window.location.reload();
          });
        } else if(response.data =="User Archived"){
          showToast("Utilisateur archivé, contactez l'administrateur", "error");
          return;
        }else if(response.data =="Unauthorized"){
          showToast("Identifiants invalides", "error");
          return;
        }else if(response.data =="No perms"){
          showToast("Aucune permission attribuée, contactez l'administrateur", "error");
          return;
        }
        else {
          // Handle case where response does not contain expected data
          console.error("Login failed: Invalid response structure");
          // proxy.$showErrorToast('Login failed');
          // toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Invalid response structure",
          //   life: 3000,
          // });
          alert("Login failed: Invalid response structure");
          return;
        }
      } catch (error) {
        console.error("Login failed:", error.response?.data || error.message);
        // alert(error.response?.data?.message || "Login failed");
      }
    };

    return {
      email,
      password,
      handleLogin,
    };
  },
};
</script>